import { cn } from '@/lib/cn';

/**
 * The supplied SmartAsset360 artwork, used as given - the wordmark is part of the image, so no
 * text is drawn beside it. `markOnly` uses the same artwork cropped to the hexagon, for the
 * collapsed sidebar.
 *
 * Two files for the full lockup: the wordmark is near-black, which disappears on a dark ground,
 * so `logo-dark.png` is the same artwork with only those letters lightened. The swap is a CSS
 * rule rather than a `dark:` variant, because this codebase themes through a `.dark` class.
 */
export function Logo({ markOnly, className }: { markOnly?: boolean; className?: string }) {
  if (markOnly) {
    return <img src="/logo-mark.png" alt="SmartAsset360" className={cn('size-9', className)} />;
  }
  return (
    <>
      <img src="/logo.png" alt="SmartAsset360" className={cn('theme-light-only h-9 w-auto', className)} />
      <img src="/logo-dark.png" alt="" aria-hidden className={cn('theme-dark-only h-9 w-auto', className)} />
    </>
  );
}
